"use client";

import { useMemo } from "react";
import { useConvexAuth, useQuery } from "convex/react";
import { api } from "@convex/_generated/api";
import type { Id } from "@convex/_generated/dataModel";
import { BuyAgainButton } from "@/components/orders/buy-again-button";

export function ListingBuyAgainButton({
  orderId,
  productId,
}: {
  orderId: Id<"orders">;
  productId: Id<"products">;
}) {
  const productIds = useMemo(() => [productId], [productId]);
  return (
    <BuyAgainButton
      orderId={orderId}
      productIds={productIds}
      variant="outline"
      className="w-full"
    />
  );
}

export function ListingBuyAgain({ productId }: { productId: Id<"products"> }) {
  const { isAuthenticated } = useConvexAuth();
  const deals = useQuery(
    api.listings.queries.getDealsOnListing,
    isAuthenticated ? { productId } : "skip",
  );
  if (!deals?.buyAgainOrderId) return null;
  return (
    <ListingBuyAgainButton orderId={deals.buyAgainOrderId} productId={productId} />
  );
}
